import { Card } from "react-bootstrap";
import React from "react";
import Navbar from "./navbar/navbar";
import "./style/style.css";

function MainPage(props) {
  return (
    <div className="main_page">
      <div className="main_page_nav">
        <Navbar />
      </div>
      <Card className="shadow-sm main_page_card">
        <div className="main_page_heading">
          <h2>{props.name}</h2>
        </div>
        <div className="main_page_subHeading">{props.desc}</div>
        <div className="main_page_input">
          <div style={{ width: "40rem" }}>{props.path}</div>
        </div>
      </Card>
    </div>
  );
}

export default MainPage;
